<template>
  <v-text-field v-model="vmnr"
                v-validate="{ regex: /^[0-9]{5}$/ }"
                :error-messages="vmnrForbiddenError ? [vmnrForbiddenError] : errors.collect('vertriebsleiterVmnr')"
                :hint="hint"
                persistent-hint
                data-vv-as="VMNR"
                name="vertriebsleiterVmnr"
                label="Bestand einer VMNR anzeigen"
                clearable
                @change="loadIdentity()"/>
</template>
<script>

import httpService from "@/helper/httpService";
import ValidationMixin from '../../components/helper/ValidationMixin';

export default {
  name: "SelectVmnr",
  mixins: [ValidationMixin],
  data() {
    return {
      vmnr: '',
      vmnrForbiddenError: null,
      hint: ''
    };
  },
  methods: {
    loadIdentity: function () {
      if (!this.vmnr) return;
      this.$validator.validate('vertriebsleiterVmnr').then((result) => {
        if (result) {
          httpService.getWhoAmI(this.vmnr).then(user => {
            this.vmnrForbiddenError = null;
            this.hint = `${user.metadata.firstname} ${user.metadata.lastname}`;
            this.$emit('vmnr-change', this.vmnr);
          }).catch((err) => {
            this.hint = '';
            this.vmnrForbiddenError = err.status === 403 ? `Kein Zugriff auf Verträge für VMNR ${this.vmnr}` : 'VMNR existiert nicht';
          });
        }
      });
    }
  }
};
</script>
